import InputValidationStateBo from "../../../../../../form/input/InputValidationStateBo";
import InputValidatorI from "../../../../../../form/input/InputValidatorI";

export default class VviBestaetigungValidator implements InputValidatorI {

    private value?: boolean;

    constructor(newValue: boolean) {
        this.value = newValue;
    }

    validate(): InputValidationStateBo {
        // Lieber true statt false
        if (true === this.value) {
            return InputValidationStateBo.createValid();

        }
        return InputValidationStateBo.createInValid("Bitte fordern Sie zunächst über den Button die Dokumente per Email an!");
    }

}